<div class="row">
  <div class="col-12">
    <div class="alert" [class]="'alert-' + type">
      <span *ngIf="message">{{ message }}</span>
      <ng-content></ng-content>
    </div>
  </div>
</div>
